import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=2f4ee5a0&scoped=true&lang=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=2f4ee5a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ee5a0",
  null
  
)

export default component.exports